import React, { Component } from 'react';
import Link from 'next/link';
import UserService from '../../services/UserService';

class DynamicButtonTTE extends Component {
  loggedOutButton = this.props.toggleJoinModal ? (
    <button
      className={`btn btn-primary btn-block text-transform-none ${this.props.className ? this.props.className : ''
        }`}
      onClick={this.props.toggleJoinModal}
      onKeyDown={this.props.toggleJoinModal}
      type="button"
    >
      {this.props.btnText ? this.props.btnText : 'Talk to an Expert'}
    </button>
  ) : (
    <Link href="/join-now">
      <a
        className={`btn btn-primary btn-block ${this.props.className ? this.props.className : ''
          }`}
      >
        Talk to an Expert
      </a>
    </Link>
  );

  loggedInButton = (
    <a
      href="/portal/#/message_center"
      className={`btn btn-primary btn-block ${this.props.className ? this.props.className : null
        }`}
    >
      Talk to an Expert
    </a>
  );

  constructor(props) {
    super(props);
    this.UserService = new UserService();
  }

  state = {
    button: this.loggedOutButton,
  };

  componentDidMount = async () => {
    const isUserLoggedIn = await this.UserService.checkToken();
    if (isUserLoggedIn) {
      this.setState({ button: this.loggedInButton });
    }
  };

  render() {
    return this.state.button;
  }
}

export default DynamicButtonTTE;
